import { combineReducers } from '@reduxjs/toolkit';
import serviceQtyListReducer from './reducers/serviceQuantity/slice';
import filterBookingReducer from './reducers/filterBooking/slice';

export const bookingCardListReducers = {
  serviceQtyListReducer,
  filterBookingReducer,
};

const rootReducer = combineReducers(bookingCardListReducers); // just used to create type BookingCardState

export type BookingCardListState = ReturnType<typeof rootReducer>;

/**
 * Don't need to export the rootReducer because it will be consumed by a parent app with its own rootReducer
 */
// export default rootReducer;
